import { $SiteColors } from "../../../config/company-atts";
import { $appAndroidLink, $appIOSLink, $userAgreementLink, $aboutDeveloperLink } from "../../../config/vars";
import { isIntfAccessDenied, keyIntfShowAndroid, keyIntfShowIos } from "../../../disabledInterfaces";

import "../styles/Footer.css";

export const Footer = () => {  
  return (
    <footer className="page__footer" style={{background: $SiteColors.getState().footerColor}}> 
      <ul className="footer__list">
        <>
          <li hidden={isIntfAccessDenied(keyIntfShowIos)}>
            <a className="footer__link" href={$appIOSLink.getState()}  target="_blank" rel="noreferrer" style={{color:$SiteColors.getState().footerLinkColor}}>
              Версия iOS 
            </a>
          </li>
          <li hidden={isIntfAccessDenied(keyIntfShowAndroid)}>
            <a className="footer__link" href={$appAndroidLink.getState()} target="_blank" rel="noreferrer" style={{color:$SiteColors.getState().footerLinkColor}}>
              Версия Android
            </a>
          </li>
        </>         
        <li>
          <a className="footer__link" href={$userAgreementLink.getState()} target="_blank" rel="noreferrer" style={{color:$SiteColors.getState().footerLinkColor}}>
            Пользовательское соглашение
          </a>
        </li>
        <li>
          <a className="footer__link" href={$aboutDeveloperLink.getState()} target="_blank" rel="noreferrer" style={{color:$SiteColors.getState().footerLinkColor}}>
            О разработчике
          </a>
        </li>
      </ul>
      <p className="footer__copyright" style={{color: $SiteColors.getState().footerCopyrightColor}}>
        &copy;IT компания АБС 2000-{new Date().getFullYear()} г. Все права защищены.
      </p>
    </footer>
  );
};
